import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUploadIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0013 7.99984V9.99984H2.0013V7.99984H0.667969V9.99984C0.667969 10.7332 1.26797 11.3332 2.0013 11.3332H10.0013C10.7346 11.3332 11.3346 10.7332 11.3346 9.99984V7.99984H10.0013ZM2.66797 3.99984L3.60797 4.93984L5.33464 3.21984V8.6665H6.66797V3.21984L8.39464 4.93984L9.33464 3.99984L6.0013 0.666504L2.66797 3.99984Z",
		fill: "#E8EAED"
	})
});
export { SvgUploadIcon as ReactComponent };
